import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import type { ReactNode } from 'react';
import { LabelBadges } from './LabelBadges';
import type { ClinicalTemplate } from './template-utils';

interface ClinicalTemplateTableProps {
  templates: ClinicalTemplate[];
  emptyText: string;
  showVisibilityLabels?: boolean;
  renderActions: (template: ClinicalTemplate) => ReactNode;
}

export function ClinicalTemplateTable({
  templates,
  emptyText,
  showVisibilityLabels = true,
  renderActions,
}: ClinicalTemplateTableProps) {
  if (templates.length === 0) {
    return <div className="py-8 text-center text-muted-foreground">{emptyText}</div>;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Nafn</TableHead>
          <TableHead>Lýsing</TableHead>
          {showVisibilityLabels && <TableHead>Sýnileiki</TableHead>}
          <TableHead className="text-right">Aðgerðir</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {templates.map((template) => (
          <TableRow key={template.id}>
            <TableCell className="font-medium">{template.name}</TableCell>
            <TableCell className="text-muted-foreground">{template.description || '-'}</TableCell>
            {showVisibilityLabels && (
              <TableCell>
                <LabelBadges labels={template.visibility_labels} emptyText="Allir í stofnun" />
              </TableCell>
            )}
            <TableCell className="space-x-1 text-right">{renderActions(template)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export function IconTableButton({
  label,
  onClick,
  disabled,
  className,
  children,
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Button variant="ghost" size="sm" aria-label={label} onClick={onClick} disabled={disabled} className={className}>
      {children}
    </Button>
  );
}
